import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  CheckboxInputComponent,
  NumberInputComponent,
} from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreConsumptionsFormEvents,
  OffshoreConsumptionsFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-water',
  templateUrl: './water.component.html',
  styleUrl: './water.component.css',
  imports: [FormsModule, CheckboxInputComponent, NumberInputComponent],
})
export class WaterComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'consumptions';
  sectionId = 'water';
  events = injectDispatch(offshoreConsumptionsFormEvents);
  consumptionsStore = inject(OffshoreConsumptionsFormStore);
}
